import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';
import {dataSortingOrder} from '../../util/uiconstants';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function formDataReducer(state = initialState.formData, action) {
	switch (action.type) {
		case types.GET_FORM_DATA: {
			return action.response;
		}
		default:
			return state;
	}
}

export function formDisplayDataBodyReducer(
	state = initialState.formBodyDisplayData,
	action
) {
	switch (action.type) {
		case types.UPDATE_FORM_BODY_RESPONSE: {
			return action.response;
		}
		default:
			return state;
	}
}

export function formBodyDataReducer(state = initialState.formBodyData, action) {
	switch (action.type) {
		case types.GET_FORM_BODIES_BY_SECTIONID: {
			if (action.response && action.response.length > 0) {
				let stateCopy = JSON.parse(JSON.stringify(state)),
					responseCopy = JSON.parse(JSON.stringify(action.response)),
					responseCopySorted = JSON.parse(JSON.stringify(action.response));

				/*sort and prep bodies for display*/
				if (responseCopy.length > 0) {
					responseCopy.sort(
						Utility.sortByMultipleKey([
							dataSortingOrder.knowledgeDisplayOrder,
							dataSortingOrder.name,
							dataSortingOrder.customLabel
						])
					);
					responseCopySorted = responseCopy.map((body) => {
						return {
							...body,
							bodyIncompleteResponseCount: 0,
							bodyUnresolvedCommentsCount: 0
						};
					});
				}
				const indexOfBodies = stateCopy.findIndex((body) => {
					return responseCopySorted[0].sectionId === body.sectionId;
				});
				if (indexOfBodies >= 0) {
					/*update the bodies for the sectionId*/
					stateCopy.splice(indexOfBodies, 1, {
						sectionId: responseCopySorted[0].sectionId,
						bodies: responseCopySorted
					});
				} else {
					/*add the bodies and the sectionId to the store*/
					stateCopy.push({
						sectionId: responseCopySorted[0].sectionId,
						bodies: responseCopySorted
					});
				}
				return stateCopy;
			} else {
				return state;
			}
		}
		case types.GET_FORM_BODIES_AFTER_RESPONSE: {
			if (action.response && action.response.length > 0) {
				return JSON.parse(JSON.stringify(action.response));
			} else {
				return state;
			}
		}
		default:
			return state;
	}
}

export function formatFormDataForRail(formData) {
	let railData = [];
	if (
		formData &&
		formData[0] &&
		formData[0].headers &&
		formData[0].headers.length > 0
	) {
		let formDataCopy = JSON.parse(JSON.stringify(formData));
		formDataCopy[0].headers.forEach((element) => {
			const secondLevel = element.sections;

			let firstLevel = JSON.parse(JSON.stringify(element));
			firstLevel.secondLevel = secondLevel;

			delete firstLevel.sections;
			railData.push(firstLevel);
		});
	}
	return railData;
}
